module.exports = __webpack_public_path__ + "img/regular.30202319.png";